<template>
  <div>
    <h1 class="text-2xl font-bold mb-4">Dashboard</h1>

    <div class="grid grid-cols-5 gap-6">
      <div class="bg-gray-100 p-4 rounded-md shadow-md">
        <h2 class="text-lg font-semibold text-gray-700">Total Views</h2>
        <p class="text-3xl font-bold text-blue-600 mt-2">{{ totalViews }}</p>
      </div>

      <div class="bg-gray-100 p-4 rounded-md shadow-md">
        <h2 class="text-lg font-semibold text-gray-700">Total Newspapers</h2>
        <p class="text-3xl font-bold text-yellow-600 mt-2">{{ totalNewspapers }}</p>
      </div>

      <div class="bg-gray-100 p-4 rounded-md shadow-md">
        <h2 class="text-lg font-semibold text-gray-700">Total Magazines</h2>
        <p class="text-3xl font-bold text-red-600 mt-2">{{ totalMagazines }}</p>
      </div>

      <div class="bg-gray-100 p-4 rounded-md shadow-md">
        <h2 class="text-lg font-semibold text-gray-700">Total Users</h2>
        <p class="text-3xl font-bold text-green-600 mt-2">{{ totalUsers }}</p>
      </div>

      <div class="bg-gray-100 p-4 rounded-md shadow-md">
        <h2 class="text-lg font-semibold text-gray-700">Total Artists</h2>
        <p class="text-3xl font-bold text-purple-600 mt-2">{{ totalArtists }}</p>
      </div>

      <div class="bg-gray-100 p-4 rounded-md shadow-md">
        <h2 class="text-lg font-semibold text-gray-700">Total Contacts</h2>
        <p class="text-3xl font-bold text-red-600 mt-2">{{ totalContacts }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'

const totalViews = ref(0)
const totalUsers = ref(0)
const totalArtists = ref(0)
const totalContacts = ref(0)
const totalNewspapers = ref(0)
const totalMagazines = ref(0)

onMounted(async () => {
  const API = process.env.VUE_APP_API_BASE_URL; // already ends with /api

  try {
    const [viewsRes, usersRes, artistsRes, contactsRes, newspapersRes, magazineRes] = await Promise.all([
      axios.get(`${API}/views`),
      axios.get(`${API}/users/count`),
      axios.get(`${API}/artists/count`),
      axios.get(`${API}/contacts/count`),
      axios.get(`${API}/newspapers/count`),
      axios.get(`${API}/magazines/count`)  // ✅ fixed: no extra /api
    ]);

    totalViews.value = viewsRes.data.total_views
    totalUsers.value = usersRes.data.total_users
    totalArtists.value = artistsRes.data.total_artists
    totalContacts.value = contactsRes.data.total_contacts
    totalNewspapers.value = newspapersRes.data.totalNewspapers
    totalMagazines.value = magazineRes.data.total
  } catch (error) {
    console.error('Error fetching dashboard data:', error)
  }
})
</script>
